import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvPillLink = styled(NavLink)`
  display: inline-block;
  padding: 0.25rem 1rem;
  border: 2px solid ${Colours.OV_BASE};
  border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
  background-color: ${Colours.OV_BASE};
  font-size: ${Variables.fontSizes.SMALL};
  font-weight: bold;
  line-height: 1.25rem;
  text-decoration: none;
  white-space: nowrap;

  /* Doubled specificity: OvRecordDetailsCanvas colours every link inside it. */
  && {
    color: ${Colours.OV_WHITE};
  }

  &&:hover {
    background-color: ${Colours.WHITE};
    color: ${Colours.OV_BASE};
  }

  &:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }
`;

export default OvPillLink;
